export default __webpack_public_path__ + "static/media/photo_gallery_8.94f160b5.png";